import Semaphore from "semaphore-async-await";
import {products} from "@/modules/utils";
import router from "@/modules/router";
import axios from "@/modules/axios";
import {get} from "lodash";

const s = new Semaphore(1);

export default {
	namespaced: true,

	state: {
		minicart: false,
		counter: {},
		data: null
	},

	mutations: {
		data(state, data) {
			state.data = data;
		},
		counter(state, item) {
			state.counter = {...state.counter, ...item};
		},
		resetCounter(state) {
			state.counter = {};
		},
		minicart(state, bool) {
			state.minicart = bool;
		}
	},

	actions: {
		async getData({commit}) {
			const {data: {data}} = await axios.get("client/carts/active");
			commit("data", data);
		},


		async updateItem({getters, commit}, {variantId, quantity}) {
			await s.acquire();

			const {data: {data}} = await axios.post(`client/carts/${getters.data.id}/items`, {quantity, variant_id: variantId});
			commit("data", data);

			s.release();
		},


		async removeItem({getters, commit}, {itemId}) {
			const variantId = getters.items.find(x => x.id === itemId).variant_id;

			const {data: {data}} = await axios.delete(`client/carts/${getters.data.id}/items/${itemId}`);
			commit("counter", {[variantId]: 0});
			commit("data", data);
		},


		async removeProduct({getters, dispatch}, {productId}) {
			const items = getters.products.find(x => x.id === productId).line_items;

			for (const item of items.reverse()) {
				await dispatch("removeItem", {itemId: item.id});
			}
		},


		async saveOrder({getters, commit, dispatch}) {
			await axios.post("client/orders", {cart_id: getters.data.id});
			router.push({name: "order", params: {id: getters.data.id}});
			await dispatch("getData");
			commit("resetCounter");
		},


		async getOrder(ctx, {cartId}) {
			return await axios.get(`client/orders/${cartId}`);
		}
	},

	getters: {
		data(state, getters, rootState, rootGetters) {
			return state.data || rootGetters["user/cart"];
		},
		items(state, getters) {
			return get(getters.data, "line_items", []);
		},
		itemsCount(state, getters) {
			return getters.items.reduce((sum, item) => sum + item.quantity, 0);
		},
		products(state, getters) {
			return products({items: getters.items});
		},
		counter(state) {
			return state.counter;
		},
		minicart(state) {
			return state.minicart;
		}
	}
};
